import React, {useEffect} from 'react';
import { BaseInput } from './BaseInput';
import { Input } from './styles';

export function TextInput({
  label = 'Label',
  renderBottomElement,
  placeholder = '',
  onChangeText = () => {},
  text = '',
  type = 'text',
  ...props
}) {

  return (
    <BaseInput
      label={label}
      renderBottomElement={renderBottomElement}
      {...props}
    >
      <Input
        placeholder={placeholder}
        onChange={(e) => onChangeText(e.target.value)}
        value={text}
        type={type}
        {...props}
      />
    </BaseInput>
  )
}